import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import '../App.css';  // ← your .button styles live here

export default function NotFoundPage() {
  // inline styles for heading + text
  const titleStyle = {
    fontSize: 'clamp(2.5rem, 6vw, 4rem)',
    color: '#007bff',
    marginBottom: '1rem',
    textShadow: '2px 2px 8px rgba(0,0,0,0.1)',
  };
  const textStyle = {
    fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
    color: '#333',
    marginBottom: '1rem',
    lineHeight: 1.5,
  };
  const italicStyle = {
    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
    fontStyle: 'italic',
    color: '#555',
    marginBottom: '2rem',
  };

  return (
    <Container className="text-center py-5">
      <h1 style={titleStyle}>😕 Oops!</h1>
      <p style={textStyle}>
        It looks like you’ve wandered off the map.  
        Either you typed the URL wrong, or this page took a hike into the sunset.
      </p>
      <p style={italicStyle}>
        Try double-checking the address, or head back home:
      </p>
      <Link to="/">
        <button className="button">
          Take me home
        </button>
      </Link>
    </Container>
  );
}
